import React, { useContext } from "react";
import Avatar from "../../VibehutUI/Avatar";
import { frontEndURL, videoAppUrl } from "../../utils/axios";
import PasswordIcon from "../../VibehutUI/Icons/PasswordIcon";
import Polygon from "../../VibehutUI/Icons/Polygon";
import Subscriptions from "../../VibehutUI/Icons/Subscriptions";
import SubscriberApproval from "../../VibehutUI/Icons/SubscriberApproval";
import useIsPWA from "../../hooks/usePWA";
import useWatchingCount from "../../hooks/useWatchingCount";
import NewTab from "../../VibehutUI/Icons/NewTab";
import { showLoginModal } from "../../actions/uiModalActions";
import { StoreContext } from "../../Context/StoreContext";
import LiveTargetIcon from "../../VibehutUI/Icons/LiveTargetIcon";

function LiveCallCard({
  call,
  isAuth,
  isBoostedCall = false,
  boostedCallDetails = {},
}) {
  const { dispatch } = useContext(StoreContext);
  const isPWA = useIsPWA();
  const callId = call?.callsArr?.[0]?._id;
  const { watchingCount, isLive, livePassCharge } = useWatchingCount(
    call?.callsArr?.[0]?._id,
  );
  const handleClick = () => {
    if (isAuth) {
      if (!isPWA) {
        window.open(`${videoAppUrl}/call?roomKey=${call.room._id}`);
      } else {
        window.location.href = `${videoAppUrl}/call?roomKey=${call.room._id}`;
      }
    } else {
      showLoginModal(dispatch);
    }
  };

  return (
    <div className="py-3 ">
      <div
        className={`z-10 flex relative drop-shadow-md items-center gap-2.5 bg-primary  rounded-2xl cursor-pointer ${isBoostedCall ? "animate-bubble animate bubbly-button" : ""}`}
        onClick={handleClick}
      >
        <div className="flex justify-between w-full h-full">
          <div className="flex  p-2.5">
            <div className="-space-x-4 flex">
              {call.users?.map((user) => (
                <div
                  className="border-3 rounded-full  border-primary z-10"
                  key={user._id}
                >
                  <div className="w-7 h-7 rounded-full">
                    <Avatar
                      src={user.profile_picture}
                      username={user.username}
                      size="xs"
                    />
                  </div>
                </div>
              ))}

              <div className="border-3 rounded-full  border-primary z-10">
                <div className="w-7 h-7 flex justify-center items-center rounded-full bg-white z-20">
                  <div class="boxContainer ">
                    <div class="box box1"></div>
                    <div class="box box2"></div>
                    <div class="box box3"></div>
                    <div class="box box4"></div>
                    <div class="box box5"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col">
              <span
                className={`text-white font-medium text-sm flex items-center gap-0.5    `}
              >
                <span className="flex space-x-1 items-center">
                  {call.room.isPasswordProtected && <PasswordIcon />}
                  {call.room?.isSubscriberRequireApproval && (
                    <SubscriberApproval ratio="18" />
                  )}
                  {call.room.isNftCollectionRoom && (
                    <Polygon
                      bgColor={call.room.isAccessible ? "#FFCC00" : "#B5B5B5"}
                      isInline={true}
                    />
                  )}
                  {call.room?.desoPostRoom?.postHashHex && <>💎</>}
                  {(call?.room?.hasSubscription ||
                    !!call?.room?.liveEvent.length) && <Subscriptions />}
                </span>
                <span className="custom-chat-line-clamp ml-0.5">
                  {call.room.name}
                </span>
              </span>
              <span className="text-white text-xs ml-0.5 whitespace-nowrap">
                {call.talkingCount} talking
                {isLive ? `, ${watchingCount || 0} watching` : ""}
              </span>
            </div>
          </div>
          {call.room.promotion && call.room.promotion.imgUrl && (
            <div className="flex justify-end max-w-[25%]">
              <img
                src={call.room.promotion.imgUrl}
                alt={call.room.promotion.title || "promotion"}
                className="flex min-w-[80px] max-h-16 rounded-br-2xl rounded-r-2xl"
              />
            </div>
          )}
        </div>
      </div>
      {isLive && (
        <a
          onClick={(e) => {
            e.stopPropagation();
          }}
          target="_blank"
          rel="noreferrer"
          href={`${frontEndURL}/rooms/${call.room._id}/calls/${callId}/live`}
        >
          <div className="bg-[#34C759] flex flex-row items-center justify-start space-x-1.5 mt-1 rounded-3xl py-0.5">
            <div></div>
            <LiveTargetIcon />
            <div className="text-white font-medium">
              LIVE: Click to watch
              <span className="text-sm">
                {livePassCharge > 0 ? ` ( $${livePassCharge} )` : ""}
              </span>
            </div>
          </div>
        </a>
      )}
      {call?.room?.promotion && (
        <div className="pt-1.5 font-normal text-xs text-center dark:text-frescoWhite text-darkGray flex items-end">
          Sponsored &#8226; {call.room.promotion?.title}
          <a
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="pt-1.5 ml-0.5 font-normal text-sm text-center dark:text-frescoWhite text-darkGray flex items-center"
            target="_blank"
            rel="noreferrer"
            href={call.room.promotion.link}
          >
            <NewTab ratio="14" />
          </a>
        </div>
      )}
      {isBoostedCall && (
        <a
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="pt-1.5 font-normal text-xs text-left dark:text-frescoWhite text-darkGray flex items-center"
          target="_blank"
          rel="noreferrer"
          href={`${frontEndURL}/call?roomKey=${call.room._id}`}
        >
          <span>
            {boostedCallDetails.message}
            <span className="pl-1 inline-block relative">
              <span className="absolute -bottom-[3px]">
                <NewTab ratio="14" />
              </span>
            </span>
          </span>
        </a>
      )}
    </div>
  );
}

export default LiveCallCard;
